import Route from '@ember/routing/route';

export default class DailyNoticesRoute extends Route {}
